import { AnimatePresence, motion, useInView } from 'framer-motion'

import LogoMainSrc from './assets/main.png'
import LogoShadowSrc from './assets/main-shadow.png'
import {
  AbsoluteImage,
  BrightImage,
  Logo,
  LogoWrapper,
  MainImage,
  StyledHeader,
} from './styled'
import {
  ITEM_LAYER_VARIANTS,
  ITEM_VARIANTS,
  LAYERS_VARIANTS,
  LOGO_VARIANTS,
} from './variants'
import { useRef } from 'react'

const LAYERS = [
  {
    main: require('./assets/docs-1-main.png'),
    shadow: require('./assets/docs-1-shadow.png'),
  },
  {
    main: require('./assets/docs-2-main.png'),
    shadow: require('./assets/docs-2-shadow.png'),
  },
  {
    main: require('./assets/docs-3-main.png'),
    shadow: require('./assets/docs-3-shadow.png'),
  },
  {
    main: require('./assets/docs-4-main.png'),
    shadow: require('./assets/docs-4-shadow.png'),
  },
  {
    main: require('./assets/docs-5-main.png'),
    shadow: require('./assets/docs-5-shadow.png'),
  },
]

export const Header = () => {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref)

  return (
    <>
      <StyledHeader>
        <motion.div ref={ref} style={{ height: '10%' }} />
      </StyledHeader>

      <LogoWrapper>
        <Logo initial="initial" animate="enter" exit="exit">
          <AnimatePresence>
            {isInView && (
              <motion.div
                variants={LAYERS_VARIANTS}
                initial="initial"
                animate="enter"
                exit="exit"
              >
                {LAYERS.map((item, index) => (
                  <motion.div key={index} variants={ITEM_VARIANTS}>
                    <AbsoluteImage
                      as={motion.img}
                      variants={ITEM_LAYER_VARIANTS}
                      src={item.shadow}
                      alt=""
                    />
                    <BrightImage
                      as={motion.img}
                      variants={ITEM_LAYER_VARIANTS}
                      src={item.main}
                      alt=""
                    />
                  </motion.div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>

          <MainImage
            variants={LOGO_VARIANTS}
            as={motion.img}
            src={LogoMainSrc}
            alt=""
          />
          <AbsoluteImage
            variants={LOGO_VARIANTS}
            as={motion.img}
            src={LogoShadowSrc}
            alt=""
          />
        </Logo>
      </LogoWrapper>
    </>
  )
}
